(function () {
  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function detectLangFromPath() {
    var p = (window.location.pathname || "").toLowerCase();
    if (p.indexOf("/en") === 0 || p.indexOf("/en-") === 0) return "en";
    if (p.indexOf("/fr") === 0 || p.indexOf("/fr-") === 0) return "fr";
    if (p.indexOf("/de") === 0 || p.indexOf("/de-") === 0) return "de";
    if (p.indexOf("/it") === 0 || p.indexOf("/it-") === 0) return "it";
    if (p.indexOf("/es") === 0 || p.indexOf("/es-") === 0) return "es";
    if (p.indexOf("/nl") === 0 || p.indexOf("/nl-") === 0) return "nl";
    return "nl";
  }

  var MONTH_NAMES = {
    nl: [
      "januari",
      "februari",
      "maart",
      "april",
      "mei",
      "juni",
      "juli",
      "augustus",
      "september",
      "oktober",
      "november",
      "december",
    ],
    en: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    fr: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
    de: [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember",
    ],
    it: [
      "gennaio",
      "febbraio",
      "marzo",
      "aprile",
      "maggio",
      "giugno",
      "luglio",
      "agosto",
      "settembre",
      "ottobre",
      "novembre",
      "dicembre",
    ],
    es: [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ],
  };

  var BATCH_LABEL_FALLBACK = {
    nl: "Batch",
    en: "Batch",
    fr: "Lot",
    de: "Charge",
    it: "Lotto",
    es: "Lote",
  };

  var EMPTY_BATCH_FALLBACK = {
    nl: "Geen batch beschikbaar.",
    en: "No batch available.",
    fr: "Aucun lot disponible.",
    de: "Keine Charge verfügbar.",
    it: "Nessun lotto disponibile.",
    es: "No hay lote disponible.",
  };

  function escapeHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function uiString(payload, key, lang) {
    var ui = (payload && payload.ui) || {};
    var fromApi = (ui[key] || "").trim();
    if (fromApi) return fromApi;
    if (key === "batch_select_label") return BATCH_LABEL_FALLBACK[lang] || BATCH_LABEL_FALLBACK.nl;
    if (key === "empty_batch_message") return EMPTY_BATCH_FALLBACK[lang] || EMPTY_BATCH_FALLBACK.nl;
    return "";
  }

  var DOWNLOAD_BTN = {
    nl: "Download PDF",
    en: "Download PDF",
    fr: "Télécharger le PDF",
    de: "PDF herunterladen",
    it: "Scarica PDF",
    es: "Descargar PDF",
  };

  function parseIsoDate(iso) {
    if (!iso) return null;
    var m = String(iso).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return null;
    return {
      y: parseInt(m[1], 10),
      mo: parseInt(m[2], 10) - 1,
      d: parseInt(m[3], 10),
    };
  }

  function formatLongDate(iso, lang) {
    var p = parseIsoDate(iso);
    if (!p) return "";
    var months = MONTH_NAMES[lang] || MONTH_NAMES.nl;
    var month = months[p.mo] || months[0];
    if (lang === "en") {
      return p.d + " " + month + " " + p.y;
    }
    return p.d + " " + month + " " + p.y;
  }

  function buildResultsTable(rows) {
    var table = document.createElement("table");
    table.className = "qb-results-table";
    var tbody = document.createElement("tbody");
    (rows || []).forEach(function (row) {
      var tr = document.createElement("tr");
      if (row.row_key === "batch_number") tr.className = "qb-row-batch";
      var th = document.createElement("th");
      th.scope = "row";
      th.textContent = row.label || "";
      var td = document.createElement("td");
      td.textContent = row.value || "";
      tr.appendChild(th);
      tr.appendChild(td);
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    return table;
  }

  function clearExplainBlock(widgetEl) {
    var wrap = widgetEl.__qbExplain;
    if (wrap) wrap.innerHTML = "";
  }

  function ensureExplainBlock(widgetEl) {
    if (widgetEl.__qbExplain) return widgetEl.__qbExplain;
    var el = document.createElement("div");
    el.className = "qb-explain";
    el.setAttribute("data-qb-explain", "true");
    var pageWidth = widgetEl.closest(".qb-page-width");
    if (pageWidth) {
      pageWidth.appendChild(el);
    } else if (widgetEl.parentNode) {
      widgetEl.parentNode.insertBefore(el, widgetEl.nextSibling);
    } else {
      widgetEl.insertAdjacentElement("afterend", el);
    }
    widgetEl.__qbExplain = el;
    return el;
  }

  function renderExplainSection(widgetEl, batch) {
    var wrap = ensureExplainBlock(widgetEl);
    wrap.innerHTML = "";
    var cards = (batch && batch.explain_cards) || [];
    if (!cards.length) return;
    if (batch.explain_title) {
      var h = document.createElement("h1");
      h.className = "title h1";
      h.textContent = batch.explain_title;
      wrap.appendChild(h);
    }
    var grid = document.createElement("div");
    grid.className = "qb-explain-grid";
    cards.forEach(function (card) {
      var article = document.createElement("article");
      article.className = "qb-explain-card";
      var head = document.createElement("header");
      head.className = "qb-explain-card-head";
      var label = document.createElement("span");
      label.className = "qb-explain-card-title";
      var dot = document.createElement("span");
      dot.className = "qb-status-dot";
      dot.setAttribute("aria-hidden", "true");
      label.appendChild(dot);
      label.appendChild(document.createTextNode(card.title || ""));
      head.appendChild(label);
      article.appendChild(head);
      var hr = document.createElement("hr");
      hr.className = "qb-explain-divider";
      article.appendChild(hr);
      if (card.batch_line) {
        var batchP = document.createElement("p");
        batchP.className = "qb-explain-batch";
        batchP.innerHTML = card.batch_line;
        article.appendChild(batchP);
      }
      if (card.body) {
        var bodyP = document.createElement("p");
        bodyP.className = "qb-explain-body";
        bodyP.textContent = card.body;
        article.appendChild(bodyP);
      }
      grid.appendChild(article);
    });
    wrap.appendChild(grid);
  }

  function applyBatchTextPlaceholders(text, batch, lang) {
    if (!text) return "";
    var bn = String((batch && batch.batch_number) || "").trim();
    var t = String(text);
    t = t.replace(/\{\{batch_number\}\}/g, bn);
    t = t.replace(/\{batch_number\}/g, bn);
    var dateLong = batch && batch.batch_date ? formatLongDate(batch.batch_date, lang) : "";
    t = t.replace(/\{\{batch_date_long\}\}/g, dateLong);
    t = t.replace(/\{\{batch_date\}\}/g, batch && batch.batch_date ? String(batch.batch_date).slice(0, 10) : "");
    return t;
  }

  function appendRichIntro(mount, className, rawHtml, batch, lang) {
    if (!rawHtml) return;
    var html = applyBatchTextPlaceholders(rawHtml, batch, lang);
    var el = document.createElement("p");
    el.className = className;
    if (html.indexOf("<") !== -1) {
      el.innerHTML = html;
    } else {
      el.textContent = html;
    }
    mount.appendChild(el);
  }

  function formatBatchOptionLabel(batch, lang) {
    var num = String(batch.batch_number || "").trim();
    var dateLong = formatLongDate(batch.batch_date, lang);
    if (!dateLong) return "#" + num;
    if (lang === "nl") return "#" + num + " van datum " + dateLong;
    if (lang === "en") return "#" + num + " from " + dateLong;
    if (lang === "fr") return "#" + num + " du " + dateLong;
    if (lang === "de") return "#" + num + " vom " + dateLong;
    if (lang === "it") return "#" + num + " del " + dateLong;
    if (lang === "es") return "#" + num + " del " + dateLong;
    return "#" + num + " — " + dateLong;
  }

  function resolveBatchNumber(widgetEl) {
    var fromAttr = widgetEl.getAttribute("data-batch-number");
    if (fromAttr) return String(fromAttr).trim();
    try {
      var q = new URLSearchParams(window.location.search);
      var b = q.get("batch");
      if (b) return String(b).trim();
    } catch (e) {}
    return "";
  }

  function resolveBatchLangView(store, lang) {
    if (!store) return null;
    if (store.v === 2) {
      lang = lang || "nl";
      var ui = (store.ui && store.ui[lang]) || (store.ui && store.ui.nl) || {};
      var published = store.published || [];
      var defNum =
        (store.default_number && store.default_number[lang]) ||
        (store.default_number && store.default_number.nl);
      var byNumber = {};
      var batchesRoot = store.batches || {};
      Object.keys(batchesRoot).forEach(function (bn) {
        var entry = batchesRoot[bn];
        var lb = (entry.langs && entry.langs[lang]) || (entry.langs && entry.langs.nl);
        if (lb) byNumber[bn] = lb;
      });
      var defaultBatch = defNum && byNumber[defNum] ? byNumber[defNum] : null;
      if (!defaultBatch) {
        var keys = Object.keys(byNumber);
        if (keys.length) defaultBatch = byNumber[keys[0]];
      }
      var companyDocuments =
        (store.company_documents && store.company_documents[lang]) ||
        (store.company_documents && store.company_documents.nl) ||
        [];
      return {
        ui: ui,
        batches: published,
        by_number: byNumber,
        default_batch: defaultBatch,
        company_documents: companyDocuments,
      };
    }
    return (store.langs && store.langs[lang]) || store[lang] || (store.langs && store.langs.nl) || store.nl;
  }

  function mergeDownloadDocuments(batchDocs, companyDocs) {
    var out = (batchDocs || []).slice();
    (companyDocs || []).forEach(function (doc) {
      if (doc && doc.url) out.push(doc);
    });
    return out;
  }

  function collectBatchChunks(index) {
    var batches = {};
    document.querySelectorAll("script.bonbon-batch-chunk[data-batch]").forEach(function (s) {
      var bn = s.getAttribute("data-batch");
      if (!bn || !s.textContent || !s.textContent.trim()) return;
      try {
        var chunk = JSON.parse(s.textContent.trim());
        var langs = chunk.langs || {};
        if (!Object.keys(langs).length) {
          langs = { nl: chunk };
        }
        batches[String(bn)] = { langs: langs };
      } catch (e) {
        qbLog("batch-chunk parse fout", bn, e);
      }
    });
    return batches;
  }

  function parseBatchStore() {
    var single = document.getElementById("bonbon-trustpilot-batch-data");
    if (single && single.textContent && single.textContent.trim()) {
      try {
        return JSON.parse(single.textContent.trim());
      } catch (e) {
        qbLog("batch_data parse fout", e);
      }
    }

    var indexEl = document.getElementById("bonbon-trustpilot-batch-index");
    var index = null;
    if (indexEl && indexEl.textContent && indexEl.textContent.trim()) {
      try {
        index = JSON.parse(indexEl.textContent.trim());
      } catch (e) {
        qbLog("batch_index parse fout", e);
      }
    }

    var chunks = collectBatchChunks(index);
    var chunkKeys = Object.keys(chunks);
    if (chunkKeys.length) {
      return {
        v: 2,
        published: (index && index.published) || [],
        ui: (index && index.ui) || {},
        default_number: (index && index.default_number) || {},
        company_documents: (index && index.company_documents) || {},
        batches: chunks,
      };
    }

    if (index && index.batches && !index.split) {
      return index;
    }

    if (index) {
      qbLog("batch_index zonder chunks", index);
    }
    return null;
  }

  function batchDomDiagnostics() {
    return {
      has_batch_data: !!document.getElementById("bonbon-trustpilot-batch-data"),
      has_batch_index: !!document.getElementById("bonbon-trustpilot-batch-index"),
      chunk_count: document.querySelectorAll("script.bonbon-batch-chunk[data-batch]").length,
    };
  }

  function qbDebug() {
    return (
      window.__BONBON_TP_DEBUG__ ||
      document.getElementById("bonbon-tp-debug-panel") ||
      document.getElementById("bonbon-batch-debug-panel") ||
      document.querySelector("[data-quality-batch-widget][data-qb-debug='1']")
    );
  }

  function qbLog() {
    if (!qbDebug()) return;
    console.log.apply(console, ["[BonBon QB]"].concat(Array.prototype.slice.call(arguments)));
  }

  function loadBatchDataLocal(widgetEl) {
    var store = parseBatchStore();
    var dom = batchDomDiagnostics();
    qbLog("DOM", dom, "store", store ? "ok" : "leeg");
    if (!store) return null;
    var lang = widgetEl.getAttribute("data-lang") || detectLangFromPath();
    var batchNumber = resolveBatchNumber(widgetEl);
    var langData = resolveBatchLangView(store, lang);
    if (!langData) {
      qbLog("resolveBatchLangView leeg", lang);
      return null;
    }
    var batch = null;
    if (batchNumber && langData.by_number && langData.by_number[batchNumber]) {
      batch = langData.by_number[batchNumber];
    } else if (langData.default_batch) {
      batch = langData.default_batch;
    }
    qbLog(
      "lang",
      lang,
      "batchNumber",
      batchNumber,
      "by_number keys",
      langData.by_number ? Object.keys(langData.by_number) : [],
      "default_batch",
      batch ? batch.batch_number : null
    );
    return {
      lang: lang,
      batches: langData.batches || [],
      ui: langData.ui || {},
      batch: batch,
      company_documents: langData.company_documents || [],
    };
  }

  function loadBatchData(widgetEl) {
    var local = loadBatchDataLocal(widgetEl);
    if (local) return Promise.resolve(local);
    return Promise.reject(
      new Error("Lokale batch-data ontbreekt. Sync op Pi en controleer metafields bonbon_trustpilot.")
    );
  }

  function buildBatchSelect(batches, currentNumber, onChange, lang, payload) {
    lang = lang || "nl";
    var wrap = document.createElement("div");
    wrap.className = "qb-batch-select-wrap";
    var label = document.createElement("label");
    label.className = "qb-batch-select-label";
    label.textContent = uiString(payload, "batch_select_label", lang);
    var sel = document.createElement("select");
    sel.className = "qb-batch-select";
    (batches || []).forEach(function (b) {
      var opt = document.createElement("option");
      opt.value = b.batch_number;
      opt.textContent = formatBatchOptionLabel(b, lang);
      if (String(b.batch_number) === String(currentNumber)) opt.selected = true;
      sel.appendChild(opt);
    });
    sel.addEventListener("change", function () {
      onChange(sel.value);
    });
    label.appendChild(sel);
    wrap.appendChild(label);
    return wrap;
  }

  function renderTable(widgetEl, chrome, body, data) {
    chrome.innerHTML = "";
    body.innerHTML = "";
    body.className = "qb-root qb-widget-body qb-widget-table";
    var batch = data.batch;
    if (!batch) {
      chrome.innerHTML =
        '<p class="qb-empty">' + escapeHtml(uiString(data, "empty_batch_message", data.lang || "nl")) + "</p>";
      clearExplainBlock(widgetEl);
      return;
    }

    var state = { batchNumber: batch.batch_number };

    function paint(payload) {
      var b = payload.batch;
      if (!b) {
        chrome.innerHTML =
          '<p class="qb-empty">' +
          escapeHtml(uiString(payload, "empty_batch_message", payload.lang || "nl")) +
          "</p>";
        clearExplainBlock(widgetEl);
        return;
      }
      var lang = payload.lang || detectLangFromPath();
      chrome.innerHTML = "";
      body.innerHTML = "";
      body.className = "qb-root qb-widget-body qb-widget-table";
      if (b.table_title) {
        var h = document.createElement("h1");
        h.className = "title h1";
        h.textContent = b.table_title;
        chrome.appendChild(h);
      }
      appendRichIntro(chrome, "qb-table-intro", b.table_intro, b, lang);
      if ((payload.batches || []).length > 1) {
        chrome.appendChild(
          buildBatchSelect(
            payload.batches,
            b.batch_number,
            function (num) {
              state.batchNumber = num;
              widgetEl.setAttribute("data-batch-number", num);
              try {
                var u = new URL(window.location.href);
                u.searchParams.set("batch", num);
                window.history.replaceState({}, "", u.toString());
              } catch (eUrl) {}
              reload();
            },
            lang,
            payload
          )
        );
      }
      body.appendChild(buildResultsTable(b.rows || []));
      renderExplainSection(widgetEl, b);
    }

    function reload() {
      loadBatchData(widgetEl, window.__qbScriptEl).then(paint);
    }

    paint(data);
  }

  function renderDownloads(widgetEl, chrome, body, data) {
    chrome.innerHTML = "";
    body.innerHTML = "";
    body.className = "qb-root qb-widget-body qb-widget-downloads";
    var batch = data.batch;
    if (!batch) {
      chrome.innerHTML =
        '<p class="qb-empty">' + escapeHtml(uiString(data, "empty_batch_message", data.lang || "nl")) + "</p>";
      return;
    }

    var state = { batchNumber: batch.batch_number };

    function paint(payload) {
      var b = payload.batch;
      if (!b) {
        chrome.innerHTML =
          '<p class="qb-empty">' +
          escapeHtml(uiString(payload, "empty_batch_message", payload.lang || "nl")) +
          "</p>";
        return;
      }
      var lang = payload.lang || detectLangFromPath();
      chrome.innerHTML = "";
      body.innerHTML = "";
      body.className = "qb-root qb-widget-body qb-widget-downloads";
      if (b.downloads_title) {
        var h = document.createElement("h1");
        h.className = "title h1";
        h.textContent = b.downloads_title;
        chrome.appendChild(h);
      }
      if (b.downloads_intro) {
        var intro = document.createElement("p");
        intro.className = "qb-downloads-intro";
        intro.textContent = applyBatchTextPlaceholders(b.downloads_intro, b, lang);
        chrome.appendChild(intro);
      }
      if ((payload.batches || []).length > 1) {
        chrome.appendChild(
          buildBatchSelect(
            payload.batches,
            b.batch_number,
            function (num) {
              state.batchNumber = num;
              widgetEl.setAttribute("data-batch-number", num);
              try {
                var u = new URL(window.location.href);
                u.searchParams.set("batch", num);
                window.history.replaceState({}, "", u.toString());
              } catch (eUrl) {}
              reload();
            },
            lang,
            payload
          )
        );
      }
      var list = document.createElement("ul");
      list.className = "qb-downloads-list";
      var btnLabel = DOWNLOAD_BTN[lang] || DOWNLOAD_BTN.nl;
      mergeDownloadDocuments(b.documents, payload.company_documents).forEach(function (doc) {
        if (!doc.url) return;
        var li = document.createElement("li");
        li.className = "qb-download-item";
        var copy = document.createElement("div");
        copy.className = "qb-download-copy";
        var strong = document.createElement("strong");
        strong.textContent = doc.title || "PDF";
        copy.appendChild(strong);
        if (doc.subtitle) {
          var span = document.createElement("span");
          span.className = "qb-download-sub";
          span.textContent = doc.subtitle;
          copy.appendChild(span);
        }
        var btn = document.createElement("a");
        btn.className = "qb-download-btn";
        btn.href = doc.url;
        btn.target = "_blank";
        btn.rel = "noopener noreferrer";
        btn.textContent = btnLabel;
        li.appendChild(copy);
        li.appendChild(btn);
        list.appendChild(li);
      });
      body.appendChild(list);
    }

    function reload() {
      loadBatchData(widgetEl, window.__qbScriptEl).then(paint);
    }

    paint(data);
  }

  function ensureWidgetLayout(widgetEl, scriptOrigin) {
    if (widgetEl.__qbChrome && widgetEl.__qbBody) {
      return Promise.resolve({ chrome: widgetEl.__qbChrome, body: widgetEl.__qbBody });
    }

    var prev = widgetEl.previousElementSibling;
    var chrome =
      prev && prev.getAttribute("data-quality-batch-chrome") === "true"
        ? prev
        : null;
    if (!chrome) {
      chrome = document.createElement("div");
      chrome.className = "qb-chrome";
      chrome.setAttribute("data-quality-batch-chrome", "true");
      var parent = widgetEl.parentNode;
      if (parent) {
        parent.insertBefore(chrome, widgetEl);
      } else {
        widgetEl.insertAdjacentElement("beforebegin", chrome);
      }
    }

    function finish(body) {
      widgetEl.__qbChrome = chrome;
      widgetEl.__qbBody = body;
      return { chrome: chrome, body: body };
    }

    return new Promise(function (resolve) {
      var shadow;
      try {
        if (widgetEl.shadowRoot) {
          shadow = widgetEl.shadowRoot;
          shadow.innerHTML = "";
        } else {
          shadow = widgetEl.attachShadow({ mode: "open" });
        }
      } catch (e) {
        var body = document.createElement("div");
        body.className = "qb-root qb-widget-body";
        widgetEl.appendChild(body);
        resolve(finish(body));
        return;
      }

      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href =
        widgetEl.getAttribute("data-widget-css") ||
        widgetEl.getAttribute("data-widget-css") || "";

      var settled = false;
      function mountBody() {
        if (settled) return;
        settled = true;
        var existing = shadow.querySelector(".qb-widget-body");
        if (existing) {
          existing.innerHTML = "";
          resolve(finish(existing));
          return;
        }
        var body = document.createElement("div");
        body.className = "qb-root qb-widget-body";
        shadow.appendChild(body);
        resolve(finish(body));
      }

      link.onload = mountBody;
      link.onerror = mountBody;
      shadow.appendChild(link);
      setTimeout(mountBody, 5000);
    });
  }

  function showBatchWidgetError(widgetEl, err) {
    var msg =
      err && err.message
        ? String(err.message)
        : "Batch-data niet beschikbaar (alleen Shopify-metafields).";
    var dom = batchDomDiagnostics();
    var detail =
      "DOM: batch_data=" +
      dom.has_batch_data +
      ", index=" +
      dom.has_batch_index +
      ", chunks=" +
      dom.chunk_count +
      ". Sync op Pi (shopify-sync). Console: [BonBon QB].";
    widgetEl.innerHTML =
      '<div style="color:#b71c1c;font-size:13px;padding:16px;border:1px dashed rgba(183,28,28,.45);line-height:1.45;margin:8px 0;">' +
      "<strong>Batch-widget:</strong> " +
      escapeHtml(msg) +
      "<br/><small>" +
      escapeHtml(detail) +
      "</small></div>";
    console.error("[BonBon QB]", err || msg, dom);
  }

  function initOneBatchWidget(widgetEl, scriptOrigin) {
    if (widgetEl.getAttribute("data-qb-initialized") === "1") {
      return Promise.resolve();
    }
    return ensureWidgetLayout(widgetEl, scriptOrigin)
      .then(function (layout) {
        return loadBatchData(widgetEl).then(function (data) {
          var format = Number(widgetEl.getAttribute("data-format") || 5);
          if (format === 6) renderDownloads(widgetEl, layout.chrome, layout.body, data);
          else renderTable(widgetEl, layout.chrome, layout.body, data);
          widgetEl.setAttribute("data-qb-initialized", "1");
        });
      })
      .catch(function (e) {
        showBatchWidgetError(widgetEl, e);
        widgetEl.setAttribute("data-qb-initialized", "1");
      });
  }

  function init() {
    if (window.__QB_BATCH_WIDGET_INIT === true) {
      return;
    }
    window.__QB_BATCH_WIDGET_INIT = true;

    var script =
      document.currentScript ||
      document.querySelector('script[data-quality-batch-src="true"]');
    window.__qbScriptEl = script;
    var scriptOrigin = script && script.src ? new URL(script.src).origin : window.location.origin;
    var widgets = Array.from(document.querySelectorAll("[data-quality-batch-widget]")).filter(
      function (el) {
        return el.getAttribute("data-qb-initialized") !== "1";
      }
    );
    if (!widgets.length) {
      return;
    }
    qbLog("init widgets", widgets.length, batchDomDiagnostics());
  Promise.all(widgets.map(function (widgetEl) {
      return initOneBatchWidget(widgetEl, scriptOrigin);
    })).catch(function (e) {
      console.error("[BonBon QB] init", e);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
